export default () => {
  const selectedLanguage = window.localStorage && window.localStorage.getItem('i18nextLng');

  if (!selectedLanguage) {
    return 'en';
  }

  return selectedLanguage;
};
